module.exports = ".container {\r\n\tfont-family: Roboto, 'Helvetica Neue', sans-serif;\r\n\tfont-size: 14px;\r\n\tcolor: rgba(0, 0, 0, 0.54);\r\n\tmin-height: 56px;\r\n\theight: auto;\r\n\t-webkit-box-sizing: border-box;\r\n\t        box-sizing: border-box;\r\n\tpadding: 0;\r\n}\r\n\r\nbutton[mat-icon-button].page-size-btn {\r\n\twidth: 64px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/my-dt/my-dt-pagination/my-dt-pagination.component.css
// module id = ./src/app/shared/components/my-dt/my-dt-pagination/my-dt-pagination.component.css
// module chunks = main